import Footer from '../Footer';
import Slider from './Slider';

const CheckoutSlider = (props) => {
	const { amount, handleSubmit, isShow } = props;

	const sliderProps = {
		label: 'Bayar dan Pesan',
		amount,
		onConfirm: handleSubmit,
		handleSize: 44,
	};

	return (
		<Footer position='fixed' className={`bottom-0 left-1/2 -translate-x-1/2 w-full max-w-lg ${isShow ? 'block' : 'hidden'}`} id='cart'>
			<Slider {...sliderProps} />
		</Footer>
	);
};

export default CheckoutSlider;
